/**
 * Builds a Shopify cart permalink (/cart/variant:qty) from a quantity input
 * and redirects straight to checkout (no cart page).
 */
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-paya-buy-now]');
  if (!(link instanceof HTMLAnchorElement)) return;

  event.preventDefault();

  const variantId = link.dataset.variantId;
  if (!variantId) return;

  let quantity = 1;
  const selector = link.dataset.quantitySelector;

  if (selector) {
    const input = document.querySelector(selector);
    if (input instanceof HTMLInputElement) {
      quantity = Math.max(1, parseInt(input.value, 10) || 1);
    }
  }

  const cartRoot = link.getAttribute('href')?.split('/').slice(0, -1).join('/') || '/cart';
  window.location.assign(`${cartRoot}/${variantId}:${quantity}`);
});
